'use client';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'next/navigation';
import { useRouterParams } from '../../_hooks/useRouterParams';
import SmallArrowDown from '@/app/_components/ui/icons/SmallArrowDown.svg';

export default function AttrFilter({ attr }) {
  const searchParams = useSearchParams();
  const [openFilter, setOpenFilter] = useState(false);
  const [selectedOption, setSelectedOption] = useState([]);
  const { checkExistattr } = useRouterParams();
  const { addParam, removeAttrParam } = useRouterParams();

  const handleAttrFilter = (e, id) => {
    if (e.target.checked) {
      addParam(`attr[${id}]`, e.target.id);
    } else {
      removeAttrParam(id, e.target.id);
    }
  };

  useEffect(() => {
    const attrs = checkExistattr(attr.id);
    setSelectedOption([...attrs]);
  }, [searchParams]);

  return (
    <div className="px-4 py-3 border border-light-gray-400 cursor-pointer rounded-md mb-3.5">
      <div
        className="filterTitle flex justify-between"
        onClick={() => setOpenFilter(!openFilter)}
      >
        <div className="text-sm font-bold"> {attr.name} </div>
        <SmallArrowDown
          className={`${openFilter ? 'rotate-180' : ''}`}
          fill="#000"
        />
      </div>

      <div
        className={` ${
          openFilter ? 'mt-4 max-h-[190px]' : 'h-0'
        }  overflow-y-auto custom-scroll-bar `}
      >
        {Object.keys(attr.options).length > 0 ? (
          Object.values(attr.options).map((option) => {
            return (
              <div
                className="w-full flex items-center border-b   grow border-light-gray-150 last:border-b-0 "
                key={option.value}
              >
                <input
                  type="checkbox"
                  id={option.value}
                  onChange={(e) => handleAttrFilter(e, attr.id)}
                  name="attr"
                  className="border border-light-gray-900 rounded-sm ml-3 w-4 h-4 mr-1"
                  checked={selectedOption.some(
                    (br) => decodeURIComponent(br) == option.value
                  )}
                />
                <div className=" py-3 text-sm">
                  <label>{option.label} </label>
                </div>
              </div>
            );
          })
        ) : (
          <></>
        )}
      </div>
    </div>
  );
}
